__turbopack_context__.v({
  "className": "IxKkoa_className",
  "variable": "IxKkoa_variable",
});
